/* wedev - start */
/* URL guard — compare only collection filter/sort params, not page/tracking/preview params. */
function __collectionQueryFingerprint(params) {
  var pairs = [];
  params.forEach(function (value, key) {
    if (key.indexOf("filter.") === 0 || key === "sort_by") {
      pairs.push(key + "=" + value);
    }
  });
  pairs.sort();
  return pairs.join("&");
}

function __collectionRequestMatchesLocation(reqUrlString) {
  if (typeof window === "undefined" || !window.location || !reqUrlString) return true;
  try {
    var req = new URL(reqUrlString, window.location.origin);
    var loc = new URL(window.location.href);
    if (req.pathname !== loc.pathname) return false;
    return __collectionQueryFingerprint(req.searchParams) === __collectionQueryFingerprint(loc.searchParams);
  } catch (e) {
    return true;
  }
}

/* wedev - end */

var MeetAjaxForProduct = function ajaxConstructor(settings) {
  var default_Data = {
    container: "#infinteLoop",
    method: "scroll",
    callback: null,
    loadingText: "Loading Now....",
    pagination: "#infinitePagination",
    offset: 800,
    sectionId: null,
  };

  var data = settings || {};
  this.data = Object.assign(default_Data, data);

  this.meetProductClick = this.meetProductClick.bind(this);
  this.meetProductScroll = this.meetProductScroll.bind(this);
  this.meetProductDestroy = this.meetProductDestroy.bind(this);
  this.meetStopProductMultipleClicks = this.meetStopProductMultipleClicks.bind(this);
  this.meetProductPaginationlnView = this.meetProductPaginationlnView.bind(this);

  this.meetProductpagination = document.querySelector(this.data.pagination);
  this.meetProductcontainer = document.querySelector(this.data.container);

  /* wedev - start */
  /* Original code removed:
     (constructor had no instance fields here; next line was: this.meetProductInitialize();)
  */
  /* New code added: lifecycle / concurrency flags for destroy + single in-flight load */
  this._destroyed = false;
  this._inFlightLoadMore = false;
  this._loadMoreTimer = null;
  this._paginationObserver = null;
  this._consecutiveFailures = 0;
  /* wedev - end */

  this.meetProductInitialize();
};

MeetAjaxForProduct.prototype.meetProductInitialize = function basedProductsInitializeTheCorrectFunctionsMethod() {
  if (this.meetProductcontainer) {
    // hide loader before initializing - making sure loader isnt shown unnecessarily (like final page)
    var loaderElement = document.getElementById("loader");
    if (loaderElement) loaderElement.style.display = "none";
    
    var initialidata = {
      click: this.meetProductClick,
      scroll: this.meetProductScroll,
    };
    if (initialidata[this.data.method]) {
      initialidata[this.data.method]();
    }
  }
};

MeetAjaxForProduct.prototype.meetProductScroll = function productsPageScrolling() {
  /* rootMargin prefetches the next page before the pagination element is actually
     visible, hiding request latency behind the user's remaining scroll distance. */
  if (this.meetProductpagination && !this._destroyed) {
    if (this._paginationObserver) {
      this._paginationObserver.disconnect();
    }
    var self = this;
    this._paginationObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self.meetProductPaginationlnView();
          }
        });
      },
      { root: null, rootMargin: this.data.offset + "px", threshold: 0 }
    );
    this._paginationObserver.observe(this.meetProductpagination);
  }
};

MeetAjaxForProduct.prototype.meetProductClick = function productsPageClicking() {
  if (this.meetProductpagination) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.meetStopProductMultipleClicks);
    }
  }
};

MeetAjaxForProduct.prototype.meetStopProductMultipleClicks = function prouctPageHandleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

MeetAjaxForProduct.prototype.meetProductPaginationlnView = function prouctPageHandleScrollEvent() {
  if (!this.meetProductpagination || !this.meetProductpagination.isConnected) return;
  if (this._destroyed) return;

  this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
  this.removeScrollListener();

  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.loadMore(this.nextPageUrl);
  }
};

MeetAjaxForProduct.prototype.loadMore = function nextPageRequest(url) {
  /* wedev - start */
  /* Original code removed:
     MeetAjaxForProduct.prototype.loadMore = function nextPageRequest(url) {
       var loaderElement = document.getElementById("loader");
       if (loaderElement) loaderElement.style.display = "block";

       setTimeout(() => {
         this.request = new XMLHttpRequest();
         this.request.onreadystatechange = function success() {
           if (this.request.readyState === 4 && this.request.status === 200) {
             var cratedPagination = this.request.responseXML.querySelector(this.data.pagination);
             var cratedContaner = this.request.responseXML.querySelector(this.data.container);
             ... (append + callback + branch + dispatchEvent)
           }
         }.bind(this);
         this.request.open("GET", url || this.nextPageUrl);
         this.request.responseType = "document";
         this.request.send();
       }, 1000);
     };
  */
  /* New code added: mutex; clearable timer; URL match before send and before append; non-200 handling; self + abort on destroy */
  if (this._inFlightLoadMore) return;
  this._inFlightLoadMore = true;

  var loaderElement = document.getElementById("loader");
  if (loaderElement) loaderElement.style.display = "block";

  var self = this;

  var MAX_CONSECUTIVE_FAILURES = 3;

  function bailOut() {
    if (!self._inFlightLoadMore) return;
    self._inFlightLoadMore = false;
    if (loaderElement) loaderElement.style.display = "none";

    self._consecutiveFailures++;
    if (self._consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
      console.warn("Infinite scroll: giving up after repeated failed requests.");
      self.removeScrollListener();
      return;
    }

    self.meetProductInitialize();
  }

  this._loadMoreTimer = setTimeout(function () {
    self._loadMoreTimer = null;
    if (self._destroyed) {
      self._inFlightLoadMore = false;
      if (loaderElement) loaderElement.style.display = "none";
      return;
    }

    var reqUrl = url || self.nextPageUrl;
    if (!__collectionRequestMatchesLocation(reqUrl)) {
      bailOut();
      return;
    }

    /* Fetch only this section's markup via Shopify's Section Rendering API,
       instead of the full page, when a sectionId is configured. */
    var fetchUrl = reqUrl;
    if (self.data.sectionId) {
      try {
        var fetchUrlObj = new URL(reqUrl, window.location.origin);
        fetchUrlObj.searchParams.set("section_id", self.data.sectionId);
        fetchUrl = fetchUrlObj.toString();
      } catch (e) {
        fetchUrl = reqUrl;
      }
    }

    self.request = new XMLHttpRequest();
    self.request.timeout = 20000;
    self.request.ontimeout = bailOut;
    self.request.onerror = bailOut;
    self.request.onreadystatechange = function success() {
      var thisRequest = self.request;
      if (!thisRequest || thisRequest.readyState !== 4) return;

      if (thisRequest.status !== 200 || !thisRequest.responseXML) {
        bailOut();
        return;
      }

      var effectiveUrl = thisRequest.responseURL || reqUrl;
      if (!__collectionRequestMatchesLocation(effectiveUrl)) {
        bailOut();
        return;
      }

      var responseXML = thisRequest.responseXML;
      var cratedPagination = responseXML.querySelector(self.data.pagination);
      var cratedContaner = responseXML.querySelector(self.data.container);

      /* A "next" link only ever points at a page that has products, so a
         response missing the container is a mismatch, not an empty page. */
      if (!cratedContaner) {
        bailOut();
        return;
      }

      if (cratedPagination) {
        self.meetProductpagination.innerHTML = cratedPagination.innerHTML;
      } else {
        self.meetProductpagination.innerHTML = ""; // Remove pagination if none left
      }

      self.meetProductcontainer.insertAdjacentHTML("beforeend", cratedContaner.innerHTML);

      if (self.data.callback && typeof self.data.callback === "function") {
        self.data.callback(responseXML);
      }

      // The callback may have destroyed this instance or started a newer request.
      if (self._destroyed || self.request !== thisRequest) return;

      self._inFlightLoadMore = false;
      self._consecutiveFailures = 0;

      if (!responseXML.querySelector(self.data.pagination + " a")) {
        console.log("No more products to load.");
        self.removeScrollListener();
        if (loaderElement) loaderElement.style.display = "none";
      } else {
        self.meetProductInitialize();
      }

      document.dispatchEvent(
        new CustomEvent("infinteScroll:loaded", {
          detail: { cratedContaner: cratedContaner },
          bubbles: true,
        })
      );
    };

    self.request.open("GET", fetchUrl);
    self.request.responseType = "document";
    self.request.send();
  }, 0);
  /* wedev - end */
};

MeetAjaxForProduct.prototype.removeScrollListener = function removeProductScroll() {
  if (this._paginationObserver) {
    this._paginationObserver.disconnect();
    this._paginationObserver = null;
  }
};

MeetAjaxForProduct.prototype.meetProductDestroy = function removeProductReturnData() {
  /* wedev - start */
  /* Original code removed:
     MeetAjaxForProduct.prototype.meetProductDestroy = function removeProductReturnData() {
       var yereData = {
         click: this.removeClickListener,
         scroll: this.removeScrollListener,
       };
       if (yereData[this.data.method]) {
         yereData[this.data.method]();
       }
       this.meetProductpagination = document.querySelector(this.data.pagination);
       this.meetProductcontainer = document.querySelector(this.data.container);
       return this;
     };
  */
  /* New code added: mark destroyed; cancel pending loadMore timeout; abort in-flight XHR; reset mutex before removing listeners */
  this._destroyed = true;
  if (this._loadMoreTimer) {
    clearTimeout(this._loadMoreTimer);
    this._loadMoreTimer = null;
  }
  if (this.request) {
    this.request.onreadystatechange = null;
    if (this.request.readyState !== 4) {
      this.request.abort();
    }
    this.request = null;
  }
  this._inFlightLoadMore = false;
  /* wedev - end */

  var yereData = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  if (yereData[this.data.method]) {
    yereData[this.data.method]();
  }
  
  // Also update elems var in case elements have changed
  this.meetProductpagination = document.querySelector(this.data.pagination);
  this.meetProductcontainer = document.querySelector(this.data.container);
  
  return this;
};

MeetAjaxForProduct.prototype.removeClickListener = function removeProductClick() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.meetStopProductMultipleClicks);
  }
};
